import { configureStore } from "@reduxjs/toolkit";
import settingDataSlice from "../stateSlice/settingDataSlice";
import clickActionReducer from "../stateSlice/clickActionSlice";
import homePageReducer from "../stateSlice/homePageSlice";
import homePostSlice from "../stateSlice/homePostSlice";
import aboutPageReducer from "../stateSlice/aboutSlice"
import faqPageReducer from "../stateSlice/faqSlice"
const store = configureStore({
  reducer: {
    settingData:settingDataSlice,
    clickAction: clickActionReducer,
    homePage: homePageReducer,
    homePost:homePostSlice,
    aboutPage:aboutPageReducer,
    faqPage:aboutPageReducer
  },
});

export default store;
